var dropdown = (function ($) {
    const _init = function () {
        if ($('.filter-dropdown').length) {
            _handleDropdowns();
        }
        _handleMobileFilters();
        _handleResize();
        _handleWpAdminBarOffset();

        window.addEventListener("resize", _handleResize);
    };

    const _handleDropdowns = function () {
        $('.filter-dropdown').on('click', function (e) {
            e.stopPropagation();
            $('.filter-dropdown').not(this).removeClass('open');
            $(this).toggleClass('open');
        });

        $('.dropdown-menu li').on('click', function () {
            let value = $(this).data('value');
            let text = $(this).text();
            let dropdown = $(this).closest('.filter-dropdown');

            dropdown.find('.dropdown-selected').text(text);
            dropdown.find('input[type="hidden"]').val(value);

            dropdown.removeClass('open');
            dropdown.closest('form').submit();
        });

        $(document).on('click', function () {
            $('.filter-dropdown').removeClass('open');
        });
    };

    const _handleMobileFilters = function () {
        const filterButton = document.getElementById("archive-content-resource-mob-filter-btn");
        const slideoutPanel = document.querySelector(".filters-slide-out");
        const closeSlideoutButton = document.querySelector(".filters-slide-out .close-slide-out");
        const overlay = document.querySelector(".slide-out-overlay");
        const header = document.getElementById("main-header");

        if (!filterButton || !slideoutPanel || !closeSlideoutButton || !overlay) return;

        const openFilters = () => {
            slideoutPanel.classList.add("active");
            $(overlay).fadeIn();
            document.body.style.overflow = 'hidden';
            header.style.zIndex = 999;
        };

        const closeFilters = () => {
            slideoutPanel.classList.remove("active");
            $(overlay).fadeOut();
            document.body.style.overflow = '';
            setTimeout(() => {
                header.style.zIndex = 9999;
            }, 200);
        };

        filterButton.addEventListener("click", openFilters);
        closeSlideoutButton.addEventListener("click", closeFilters);
        overlay.addEventListener("click", closeFilters);
        document.addEventListener("click", (event) => {
            if (!slideoutPanel.contains(event.target) && !filterButton.contains(event.target)) {
                closeFilters();
            }
        });
    };

    const _handleResize = function () {
        if (window.innerWidth >= 992) {
            document.querySelector(".filters-slide-out")?.classList.remove("active");
            $(".slide-out-overlay").fadeOut();
            document.body.style.overflow = "";
        }
    };

    const _handleWpAdminBarOffset = function () {
        const wpAdminBar = document.getElementById("wpadminbar");
        const filterPanel = document.querySelector(".filters-slide-out");

        if (!wpAdminBar || !filterPanel) return;

        const updatePosition = () => {
            const wpAdminBarRect = wpAdminBar.getBoundingClientRect();
            const visibleHeight = Math.max(0, wpAdminBarRect.bottom);
            filterPanel.style.top = `${visibleHeight}px`;
        };

        updatePosition();
        window.addEventListener("scroll", updatePosition);
        window.addEventListener("resize", updatePosition);
    };

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = dropdown;